import React from 'react'
import PropTypes from 'prop-types'
import ReactInputNumber from 'rc-input-number'
import classnames from 'classnames'

import './InputNumber.scss'

export const INPUT_NUMBER_VARIANT_DANGER = 'danger'

export const InputNumber = ({
  autoFocus,
  className,
  decimalSeparator,
  defaultValue,
  disabled,
  downHandler,
  focusOnUpDown,
  formatter,
  id,
  inputMode,
  max,
  min,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onPressEnter,
  parser,
  pattern,
  placeholder,
  precision,
  readOnly,
  required,
  step,
  style,
  upHandler,
  value,
  variant,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <ReactInputNumber
      prefixCls='e-input-number'
      autoFocus={autoFocus}
      className={classnames(className, {
        'e-input-number--danger': variant === INPUT_NUMBER_VARIANT_DANGER
      })}
      decimalSeparator={decimalSeparator}
      defaultValue={defaultValue}
      disabled={disabled}
      downHandler={downHandler}
      focusOnUpDown={focusOnUpDown}
      formatter={formatter}
      id={id}
      inputMode={inputMode}
      max={max}
      min={min}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onClick={onClick}
      onFocus={onFocus}
      onPressEnter={onPressEnter}
      parser={parser}
      pattern={pattern}
      placeholder={placeholder}
      precision={precision}
      readOnly={readOnly}
      required={required}
      step={step}
      style={style}
      upHandler={upHandler}
      value={value}
      data-mu-test={classnames('input', dataAttributeTest)}
    />
  )
}

InputNumber.propTypes = {
  /* Additional classes */
  className: PropTypes.string,
  /* Specifies the minimum value */
  min: PropTypes.number,
  /* PLaceholder */
  placeholder: PropTypes.string,
  onClick: PropTypes.func,
  /* Specifies the maximum value */
  max: PropTypes.number,
  /* or string	1	Specifies the legal number intervals */
  step: PropTypes.number,
  /* Specifies the precision length of value */
  precision: PropTypes.number,
  /* false	Specifies that an InputNumber should be disabled */
  disabled: PropTypes.bool,
  /* true	whether focus input when click up or down button */
  focusOnUpDown: PropTypes.bool,
  /* false	Specifies that an InputNumber is required */
  required: PropTypes.bool,
  /* false	Specifies that an InputNumber should automatically get focus when the page loads */
  autoFocus: PropTypes.bool,
  /* false	Specifies that an InputNumber is read only */
  readOnly: PropTypes.bool,
  /* Specifies the name of an InputNumber */
  name: PropTypes.string,
  /* Specifies the id of an InputNumber */
  id: PropTypes.string,
  /* Specifies the value of an InputNumber */
  value: PropTypes.number,
  /* Specifies the defaultValue of an InputNumber */
  defaultValue: PropTypes.number,
  /* Called when value of an InputNumber changed */
  onChange: PropTypes.func,
  /* Called when user leaves an input field */
  onBlur: PropTypes.func,
  /* The callback func that is triggered when Enter key is pressed. */
  onPressEnter: PropTypes.func,
  /* Called when an element gets focus */
  onFocus: PropTypes.func,
  /* root style. such as {width:100} */
  style: PropTypes.object,
  /* custom the up step element */
  upHandler: PropTypes.node,
  /* custom the down step element */
  downHandler: PropTypes.node,
  /* Specifies the format of the value presented */
  formatter: PropTypes.func,
  /* Specifies the value extracted from formatter */
  parser: PropTypes.func,
  pattern: PropTypes.string,
  /* Specifies the decimal separator */
  decimalSeparator: PropTypes.string,
  /* Specifies the inputmode of input */
  inputMode: PropTypes.string,
  variant: PropTypes.oneOf([INPUT_NUMBER_VARIANT_DANGER]),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
